import React from "react";
import styled from "styled-components";
import { greyColor } from "./colors";
import { Content } from "./Content";
import { ExternalLink } from "./ExternalLink";
import { FooterCopyright } from "./Footer";
import { DeviceWidth, mobileQuery, useDeviceWidthQuery } from "./MediaQuery";
import { FacebookMenuItem } from "./MenuItem";
import { facebookPageUrl } from "./navigation/NavigationCommon";

const Menu: React.FC = () => (
  <Menuwrapper>
    <a href="/">
      <MenuLogo src="/share-menu-logo.svg" />
    </a>

    <ExternalLink href={facebookPageUrl}>
      <FacebookMenuItem />
    </ExternalLink>
  </Menuwrapper>
);

export const ShareMenu: React.FC = () => {
  const deviceWidth = useDeviceWidthQuery();
  return deviceWidth === DeviceWidth.desktop ? (
    <Content>
      <Menu />
    </Content>
  ) : (
    <Menu />
  );
};

const Menuwrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0 8px;
`;

const MenuLogo = styled.img`
  :hover {
    filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.3));
  }
`;

export const ShareFooter = styled(FooterCopyright)`
  background: ${greyColor};

  * {
    color: #fff !important;
  }

  ${mobileQuery`
    margin-top: 32px;
  `}
`;
